import * as AnnotationTaskClient from '../clients/annotation-task.client';
import * as adminActions from '../actions/admin.actions';
import { AppThunk } from '../../../store/rootReducer';
import { FormValues } from '../types/annotation-task-detail.type';
import { displayNotification } from '../../../shared/notification/display-notification';

export const addNewAnnotationTask =
  (values: FormValues): AppThunk =>
  async (dispatch) => {
    try {
      const newtask = await AnnotationTaskClient.createAnnotationTask(values);
      if (!newtask) {
        throw new Error('No task created');
      }

      dispatch(
        adminActions.addNewTask({
          newtask: newtask,
          meta: {
            history: false,
          },
        }),
      );
      displayNotification({
        title: 'Success',
        description: 'The task has been created',
        status: 'success',
      });
      return newtask;
    } catch (error) {
      displayNotification({
        title: 'Error',
        description: `${error}`,
        status: 'error',
      });
    }
  };
